"use strict";
angular.module("iwoPlannedOrderInfoEditModule", []).directive("iwoPlannedOrderInfoEdit", ["$templateRequest", "$stateParams", "$compile", "$q", "editingCenterService", "editingMediatype", "trsHttpService", "editIsLock", "$validation", "storageListenerService", "$state", "$timeout", "modalDialog", function($templateRequest, $stateParams, $compile, $q, editingCenterService, editingMediatype, trsHttpService, editIsLock, $validation, storageListenerService, $state, $timeout, modalDialog) {
    return {
        restrict: "A",
        replace: false,
        scope: {
            infoDetail: "=",
            callback: "&"
        },
        link: function($scope, $element, attrs) {
            initStatus();
            /**
             * [initStatus description] 状态初始化
             * @return {[type]} [description]
             */
            function initStatus() {
                $scope.status = {
                    showplannedOrderInfo: false,
                    plannedOrderDocSaveMethod: ["savePersonalChuanLianDoc", "saveReceivedChuanLianDoc"],
                }
                $scope.data = {
                    METADATAID: $stateParams.iwometadataid,
                    channelItems: [{ name: "电视", value: 0 }],
                    columnItems: [{ name: "请先选择产品" }]
                }
                getTemplate();
                initElementClick();
                // initBlur();
            }
            /**
             * [initElementClick description] 初始化主元素的点击事件
             * @return {[type]} [description]
             */
            function initElementClick() {
                $element.bind("click", function() {
                    if (!$scope.status.showplannedOrderInfo) {
                        $scope.status.showplannedOrderInfo = true;
                        getCopy();
                    } else {
                        $scope.status.showplannedOrderInfo = false;
                    }
                    $scope.$apply();
                });
            }
            /**
             * [initElementEvent description] 初始化聚焦失焦事件
             * @return {[type]} [description]
             */
            function initBlur() {
                var blur = function(e) {
                    var $target = $(e.target);
                    if ($target[0] !== $element[0] && $target[0] !== $scope.status.template[0] && $target.parents(".plannedOrder_info_container")[0] !== $scope.status.template[0]) {
                        $scope.status.showplannedOrderInfo = false;
                    }
                }
                $("body").bind("mouseup", blur);
                $scope.$on("$destroy", function() {
                    $("body").unbind("mouseup", blur);
                });
            }
            /**
             * [getTemplate description] 获取模板
             * @return {[type]} [description]
             */
            function getTemplate() {
                $templateRequest("./editingCenter/iWo/myManuscript/personalManuscript/plannedOrderEdit/directive/iwoPlannedOrderInfoEdit/iwoPlannedOrderInfoEdit_tpl.html").then(function(template) {
                    $scope.status.template = $compile(template)($scope);
                    $("body").append($scope.status.template);

                });
            }
            /**
             * [getCopy description] 数据备份
             * @return {[type]} [description]
             */
            function getCopy() {
                $scope.data.backupData = angular.copy($scope.infoDetail);
            }
            /**
             * [close description] 关闭
             * @return {[type]} [description]
             */
            $scope.close = function() {
                $scope.infoDetail = $scope.data.backupData;
                $scope.status.showplannedOrderInfo = false;
            }
            /**
             * [save description] 假保存
             * @return {[type]} [description]
             */
            $scope.save = function() {
                var defer = $q.defer();
                $scope.plannedOrderForm.$pending = {};
                $validation.validate($scope.plannedOrderForm)
                    .success(function() {
                        $scope.status.showplannedOrderInfo = false;
                        $scope.callback();
                        defer.resolve();
                    }).error(function() {
                        defer.reject();
                    });
                return defer.promise;
            }
        }
    }
}]);